import Joi from "joi";
import { useEffect, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import { getUserPageBlocks } from "../../../../../action/common/commonActionCreator";
import { createDepartmentResource } from "../../../../../action/masters/departmentResourceActionCreator";
import FloatingLabelTextInput from "../../../../../common-components/floatingtextinput";
import { validateFields } from "../../../../../helper/joi-validation";
import {
  getAlertData,
  alertConstants,
} from "../../../../../helper/sweet-alert";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";
import {
  ICreateDepartmentResource,
  IDepartmentResourceCreateData,
} from "../../../../../models/master/departmentResources";
import LoaderSpinner from "../../../../../common-components/loader";
import { masterType } from "../../../../../constants/masterTypes";
import { urlRegex } from "../../../../../constants/commonConstants";

const CreateDepartmentResource = (props: ICreateDepartmentResource) => {
  const {
    createDepartmentResource,
    setShowCreate,
    pageBlocks,
    getAllDepartmentResources,
    getUserPageBlocks,
    userDetails,
  } = props;

  const initialData: IDepartmentResourceCreateData = {
    name: "",
    file: null,
    url: "",
    sso: "",
    description: "",
    isActive: true,
    priority: 0,
    pageBlockIds: [],
    collegeId: 0,
    departmentId: 0,
  };

  // states
  const [data, setData] = useState(initialData);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  // const ssoOptionsList = Object.entries(booleanOptions).map(([key, value]) => ({
  //   id: value,
  //   name: key,
  // }));
  // const [isSSOEnabled, setIsSSOEnabled] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [imageName, setImageName] = useState<string | null>(null);

  // change the data at the time onchange fields
  const onChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    errors && delete errors[event.target.name];
    if (pageBlocks && pageBlocks.length > 0) {
      data.pageBlockIds = [pageBlocks[0].id];
    }
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    errors && delete errors[event.target.name];
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setImageName(selectedFile.name);
      const fileType = selectedFile.type;
      const validFileTypes = [
        "image/png",
        "image/ico",
        "image/svg+xml",
        "image/x-icon",
      ];
      if (!validFileTypes.includes(fileType)) {
        setErrors({
          ...errors,
          file: "Invalid file type. Please upload an icon.",
        });
      } else {
        setData({ ...data, [event.target.name]: selectedFile });
        const fileURL = URL.createObjectURL(selectedFile);
        setImagePreview(fileURL);
      }
    }
  };

  const schema = Joi.object().keys({
    name: Joi.string().required().label("Resource Name is required"),
    description: Joi.string().required().label("Description is required"),
    url: Joi.string().required().regex(urlRegex).label("Enter Valid URL"),
    file: Joi.object().required().label("Icon is required"),
    sso: Joi.string().when("isSSOEnabled", {
      is: true,
      then: Joi.string().required().regex(urlRegex).label("Enter Valid SSO"),
      otherwise: Joi.string().allow("", null).optional(),
    }),
  });

  const validationData = {
    ...data,
    // isSSOEnabled: isSSOEnabled,
  };

  const onSave = async () => {
    const validationErrors = validateFields(validationData, schema);
    if (validationErrors === undefined) {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("description", data.description.replace(/\s+$/g, ""));
      formData.append("file", data.file);
      formData.append("url", data.url);
      formData.append("sso", data.sso);
      formData.append("isActive", data.isActive.toString());
      formData.append("priority", data.priority.toString());
      formData.append("collegeId", userDetails.currentCollege.id.toString());
      formData.append(
        "departmentId",
        userDetails.currentDepartment.id.toString()
      );
      data.pageBlockIds.map((item, index) => {
        formData.append(`pageBlockIds[${index}]`, item.toString());
      });

      setLoading(true);
      setIsDisabled(true);
      try {
        await createDepartmentResource(formData, setAlert);
      } finally {
        setLoading(false);
        setIsDisabled(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  // setting sweet alert dynamically
  const setAlert = (type: string, name?: string) => {
    let alertData = getAlertData(type, name);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  // executed on clicking 'OK' in sweet alert.
  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else {
      getAllDepartmentResources();
      setShowCreate(false);
    }
  };

  useEffect(() => {
    getUserPageBlocks(UserTypes.Staff, masterType.departmentResource);
  }, []);

  return (
    <>
      <div className="modal-header">
        <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
          Add New Department Resource
        </h1>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={() => setShowCreate(false)}
        ></button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-md-12 form-group">
            <FloatingLabelTextInput
              label={"Resource Name"}
              onChange={onChange}
              isMandatory={true}
              value={data.name}
              name={"name"}
              maxLength={50}
            />
            {errors?.name && <div className="text-danger">{errors.name}</div>}
          </div>
          <div className="col-md-12 form-group">
            <label className="profile_details_text">
              Description <i className="label-asterisk"> * </i>
            </label>
            <textarea
              name="description"
              value={data.description}
              onChange={onChange}
              maxLength={1000}
            ></textarea>
            {errors?.description && (
              <div className="text-danger">{errors.description}</div>
            )}
          </div>
          <div className="col-md-6 form-group">
            <div className="d-flex">
              <label className="profile_details_text">
                Icon<i className="label-asterisk"> * </i>
              </label>
              <p className="ms-2 label-info">
                <i className="fa-solid fa-circle-info"></i>
                <span>
                  Upload an icon (SVG, PNG, or ICO). For best results, use a
                  square shape with a transparent background.
                </span>
              </p>
            </div>
            <div className="inputfile-flex">
              {imagePreview && (
                <div className="inputfile-img">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
              )}
              <div className="inputfile-wrap">
                <input
                  type="file"
                  name="file"
                  id="image"
                  className="form-control d-none"
                  required
                  onChange={onFileChange}
                  accept="image/png, image/svg+xml, image/x-icon, image/ico, .svg, .png, .ico,"
                  value={errors?.file && ""}
                />
                <div className="inputfile">
                  <label htmlFor="image">Choose File</label>
                  <span>
                    {imageName
                      ? imageName.trim().split("/").pop()
                      : "No File Choosen"}
                  </span>
                </div>
              </div>
            </div>
            {errors?.file && <div className="text-danger">{errors.file}</div>}
          </div>
          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"URL"}
              onChange={onChange}
              isMandatory={true}
              value={data.url}
              name={"url"}
              maxLength={500}
            />
            {errors?.url && <div className="text-danger">{errors.url}</div>}
          </div>
          {/* <div className="col-md-6 form-group">
            <FloatingLabelDropDown
              label={"Is SSO Enabled "}
              onChange={(e: any) => setIsSSOEnabled(e.target.value)}
              isMandatory={true}
              value={isSSOEnabled}
              name={"isSSOEnabled"}
              optionsList={ssoOptionsList}
            />
          </div>
          {isSSOEnabled && (
            <div className="col-md-6 form-group">
              <FloatingLabelTextInput
                label={"SSO"}
                onChange={onChange}
                isMandatory={true}
                value={data.sso}
                name={"sso"}
                maxLength={500}
              />
              {errors?.sso && <div className="text-danger">{errors.sso}</div>}
            </div>
          )} */}
          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"College Name "}
              onChange={onChange}
              isMandatory={true}
              value={userDetails?.currentCollege?.name}
              name={"collegeId"}
              disable
            />
          </div>
          <div className="col-md-6 form-group">
            <FloatingLabelTextInput
              label={"Department Name "}
              onChange={onChange}
              isMandatory={true}
              value={userDetails?.currentDepartment?.name}
              name={"departmentId"}
              disable
            />
          </div>
          <div
            // className={
            //   isSSOEnabled === true
            //     ? "col-md-12 form-group"
            //     : "col-md-6 form-group"
            // }
            className="col-md-12 form-group"
          >
            <FloatingLabelTextInput
              label={"Page-Block "}
              onChange={onChange}
              isMandatory={false}
              value={pageBlocks?.[0]?.name}
              name={"pageBlockIds"}
              disable
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSave}
            disabled={isDisabled}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={() => setShowCreate(false)}
            disabled={isDisabled}
          >
            Close
          </button>
        </div>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
      {loading && <LoaderSpinner />}
    </>
  );
};

const mapDispatchToProps = {
  createDepartmentResource: (data: any, callBack: Function) =>
    createDepartmentResource(data, callBack),
  getUserPageBlocks: (userType: number, masterType: string) =>
    getUserPageBlocks(userType, masterType),
};

function mapStateToProps(state: any) {
  return {
    pageBlocks: state.common.pageBlocks,
    userDetails: state.userDetails.userProfileData,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateDepartmentResource);
